import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsTotalWinLimitSliderControl } from "../ags-total-win-limit-slider-control";

export class AgsTotalWinLimitSliderControlFactory implements ControlFactory {
    
    /**
     * This method checks if the required graphics assets are available in the layer.
     * @param layer - The layer containing the graphics elements.
     * @returns A boolean value indicating if the required graphics assets are present in the layer.
     */
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("total_win_limit_slider_track") != null &&
            layer.getSprite("total_win_limit_slider_fill") != null &&
            layer.getSprite("total_win_limit_slider_handle") != null &&
            layer.getFlexiText("total_win_limit_slider_label") != null
        );
    }
    
    /**
     * Builds a total win limit slider control based on the given layer.
     *
     * @param {Layers} layer - The layer to build the control from.
     * @returns {AgsTotalWinLimitSliderControl[]} - An array of AgsTotalWinLimitSliderControl objects built from the given layer.
     */
    public build(layer: Layers): AgsTotalWinLimitSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("total_win_limit_slider_track"),
            layer.getSprite("total_win_limit_slider_fill"),
            layer.getSprite("total_win_limit_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const title = layer.getFlexiText("total_win_limit_slider_title");
        const backgroundGraphic = layer.getSprite("bg_box_total_win_limit_slider");

        const label = layer.getFlexiText("total_win_limit_slider_label");
        return [new AgsTotalWinLimitSliderControl(slider, label, title, backgroundGraphic)];
    }
}
